<template>
    <v-container grid-list-md pa-0 relative>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-card outlined class="primary--border">
                    <v-card-title class="title">
                        {{ecaTitle}}
                        <v-spacer></v-spacer>
                        <transition name="animate-css-transition" enter-active-class="animated fadeInRight"
                                    leave-active-class="animated fadeOutRight">
                            <add-button permission="exam-create" @action="form.dialog = true">
                                &nbsp; New ECA lists
                            </add-button>
                        </transition>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :hide-default-footer="form.items.data.length<11"
                            :items="form.items.data"
                            footer-props.items-per-page-options="rowsPerPageItems"
                            :options.sync="pagination"
                            :server-items-length="form.items.meta.total"
                            :loading="form.loading">
                        <template  v-slot:item="{index, item}">
                            <tr>
                                <td>{{ index + form.items.meta.from }}</td>
                                <td class="text-xs-left">
                                    {{ item.name }}
                                </td>
                                <td class="text-xs-right">
                                    <edit-button permission="exam-update" @agree="form.edit(item)"/>
                                    <delete-button permission="exam-delete" @agree="form.delete(item.id)"/>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <v-dialog v-model="form.dialog" persistent max-width="500px">
                <v-card>
                    <v-card-title class="primary white--text">
                        <span class="title">Add/Update</span>
                    </v-card-title>
                    <v-card-text class="pb-1">
                        <v-form ref="form" @submit.prevent="save"
                                @keydown.native="form.errors.clear($event.target.name)" @keyup.enter="save"
                                lazy-validation>
                            <v-text-field autocomplete="off" label="Name*"
                                          required class="pa-0 pt-3"
                                          v-model="form.name"
                                          name="name" :error-messages="form.errors.get('name')" outlined dense/>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="warning" outlined @click="form.dialog = false, form.reset()">Close</v-btn>
                        <v-btn color="success" outlined @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapState} from 'vuex'
    import Form from '@/library/Form'

    export default {
        data: () => ({
            form: new Form({
                name: '',
                eca_head_id: '',
            }, '/api/eca-list'),
            search: null,
            rowsPerPageItems: [5, 10, 25, 50, 75],
            pagination: {
                rowsPerPage: 10,
            },
            ecaTitle: '',
            headers: [
                {text: '#', align: 'center', value: 'id', width: 50, sortable: false},
                {text: 'Name', align: 'left', value: 'name'},
                {text: 'Action', align: 'left', sortable: false, width: 200}
            ],

        }),

        computed: {
            ...mapState(['batch'])
        },

        watch: {
            'pagination': function () {
                this.get();
            },
            'batch': function (value) {
                this.get();
            }
        },
        mounted() {
            // this.$rest.get('/api/eca-head/' + this.$route.params.ecaHeadId).then(res => {
            //     console.log(res);
            //     if (res.data.data.length) this.ecaTitle = res.data.data.name;
            // });
            // console.log(this.$route.params.ecaHeadId)
        },

        methods: {
            queryString() {
                let json = this.pagination;
                return '?' +
                    Object.keys(json).map(function (key) {
                        if (![null, undefined].includes(json[key]))
                            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
                    }).join('&') + '&ecaHeadId=' + this.$route.params.ecaHeadId;
            },

            get(params) {
                let query = [null, undefined].includes(params) ? this.queryString() : params;
                this.form.get(null, query).then(({data}) => {
                    this.ecaTitle = data.eca_head.name;
                    this.pagination.totalItems = data.meta.total
                })
            },

            save() {
                this.form.eca_head_id = this.$route.params.ecaHeadId;
                this.form.store();
            },

        }
    }
</script>
<style lang="scss" scoped></style>